import { Divider, Paper, Stack, Typography } from '@mui/material'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'

const IdentityCell = ({ label, value }) => (
  <Stack spacing={0.3}>
    <Typography
      variant='caption'
      sx={{ textTransform: 'uppercase', letterSpacing: '0.08em', color: 'text.secondary' }}
    >
      {label}
    </Typography>
    <Typography sx={{ fontSize: 19, fontWeight: 600, color: 'primary.main', fontFamily: 'monospace' }}>
      {value || ''}
    </Typography>
  </Stack>
)

/**
 * H112_S1 — read-only "assembly identity" card shown between the BOM header fields and the tree,
 * only in the tree view. Variant C (cerrada con el PO): raised block on `background.paper`, the two
 * values in `primary.main`, the cells split by a vertical divider — visually distinct from the
 * editable Version/Index/Revision BOM fields so it reads as static data. Renders nothing when there
 * is no identity (H112_S7/DEC-2). It is display-only: no input, nothing editable (H112_S3).
 * @param {{engItem: string, engRevision: string} | null} props.identity
 */
const BomEngineeringIdentityCard = ({ identity }) => {
  const { t_ } = useSmartTranslation()
  if (!identity) {
    return null
  }
  return (
    <Paper
      data-testid='bom-engineering-identity'
      elevation={0}
      sx={{ backgroundColor: 'background.paper', borderRadius: 2, px: 2.5, py: 1.5, alignSelf: 'flex-start' }}
    >
      <Stack direction='row' spacing={4.5} divider={<Divider orientation='vertical' flexItem />}>
        <IdentityCell label={t_('Engineering item')} value={identity.engItem} />
        <IdentityCell label={t_('Engineering revision')} value={identity.engRevision} />
      </Stack>
    </Paper>
  )
}

export default BomEngineeringIdentityCard
